import React, {useState, useEffect, useMemo } from "react";
import PdfReader from '../../pures/adobePfdReader/PdfReader'
import { ButtonHLPure, DialogPdf } from '../../pures';
import "./consult-negotiation-pdf.css";

const ConsultNegotationPDFView = (props) => {

    const {
        url
    } = props

    const [urlPdf, setUrlPdf] = useState(url)
    const [blobAWS, setBlobAWS] = useState(url);

    useEffect(() => {
        setUrlPdf(url)
        setBlobAWS(url)
    }, [url])

    const pdf = useMemo(() => <PdfReader className="pdfReader" url={urlPdf} awsURL showDownloadPDF={false} />, [urlPdf])

    return (
        <div>
            <div className='consultNegotationPDFView-documentPDF-container'>
                {pdf}
            </div>
            <div className="consultNegotationPDFView-documentPDF-pdf-btn">
                <DialogPdf blobUrl={blobAWS} />
            </div>
        </div>
    )
}

export { ConsultNegotationPDFView as default }